// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"161":"b5dbab52","536":"40a70ba7"}[chunkId] + ".chunk.js";
};